import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-mist contour-light py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-121" data-mp="1iwcsuyp5oc9i">
      <div className="mx-auto max-w-6xl px-4" data-id="element-122" data-mp="1dxt6ix6ngygm">
        <div className="text-center" data-id="element-123" data-mp="2bk8oe02zny4p">
          <span className="inline-flex items-center gap-2 rounded-md bg-navy px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-yellow" data-id="element-124" data-mp="2bj7fo29g3nq5">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-125" data-mp="26jbba1wu5ua2" /> Material completo para el aula
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-126" data-mp="1wn876qifblkh">
            Los {totalVolumes} tomos del Mega Pack
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-127" data-mp="q4jfrg4e86wj">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border-2 border-yellow bg-white shadow-card" data-id="element-128" data-mp="1iuyxk0izp5u1" data-mpi={index}>
                <div className="flex items-center gap-4 border-b border-line bg-white px-6 py-5" data-id="element-129" data-mp="14vzcf2uor92m">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-navy text-yellow" data-id="element-130" data-mp="q736bbc6w64n">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-131" data-mp="v6phzgcddebc" />
                  </span>
                  <div data-id="element-132" data-mp="h5mvj2hgq1zw">
                    <p className="text-[11px] font-extrabold uppercase tracking-[.18em] text-muted" data-id="element-133" data-mp="h6et2iume9st">
                      Tomo {module.number}
                    </p>
                    <h3 className="mt-1 text-lg font-extrabold leading-tight text-ink" data-id="element-134" data-mp="2nuf3607w8g7w">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-135" data-mp="2j1c97qz7f4r6">
                  <p className="font-semibold text-navySoft" data-id="element-136" data-mp="2e5dnkb59g0ug">{module.subtitle}</p>

                  <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[.16em] text-muted" data-id="element-137" data-mp="295r9jzhlygkl">
                    ¿Qué resuelve en el aula?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-138" data-mp="31twx0u01qjo4">{module.classroom}</p>

                  <ul className="mt-5 grid flex-1 gap-2" data-id="element-139" data-mp="31s3lp1ehnb9s">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-ink" data-id="element-140" data-mp="2wwwpeenjt8uw">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green" aria-hidden="true" data-id="element-141" data-mp="2svb6ococ20cs" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-green bg-greenSoft p-4 text-sm leading-relaxed text-ink" data-id="element-142" data-mp="1hci8w533z7cc">
                    <b className="font-extrabold text-green" data-id="element-143" data-mp="3szlpzcfx9u21">Resultado: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl bg-navy px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-144" data-mp="5uw6vg2azxrr">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-yellow" data-id="element-145" data-mp="flh1kseuwi5e">Colección principal</p>
          <p className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-146" data-mp="kkaccd2rdv1v">
            {totalVolumes} tomos premium <span className="mx-2 text-yellow" data-id="element-147" data-mp="onzyywzvi2k9">·</span> Contenido actualizado 2026
          </p>
        </div>
      </div>
    </section>;
}